export const USER_ACTIONS = {
  USER_LOGGED_IN: "USER_LOGGED_IN",
  USER_NOT_LOGGED_IN: "USER_NOT_LOGGED_IN",
  SET_USER_ATTRIBUTES: "SET_USER_ATTRIBUTES",
};

export const CONNECTIONS_ACTIONS = {
  SET_CHART_FILTERS: "SET_CHART_FILTERS",
};
